/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalApiPeriodicScenarioAttributes } from './InternalApiPeriodicScenarioAttributes';
import {
    InternalApiPeriodicScenarioAttributesFromJSON,
    InternalApiPeriodicScenarioAttributesFromJSONTyped,
    InternalApiPeriodicScenarioAttributesToJSON,
    InternalApiPeriodicScenarioAttributesToJSONTyped,
} from './InternalApiPeriodicScenarioAttributes';
import type { InternalApiScenarioVersionStatus } from './InternalApiScenarioVersionStatus';
import {
    InternalApiScenarioVersionStatusFromJSON,
    InternalApiScenarioVersionStatusFromJSONTyped,
    InternalApiScenarioVersionStatusToJSON,
    InternalApiScenarioVersionStatusToJSONTyped,
} from './InternalApiScenarioVersionStatus';
import type { InternalApiScenarioLanguage } from './InternalApiScenarioLanguage';
import {
    InternalApiScenarioLanguageFromJSON,
    InternalApiScenarioLanguageFromJSONTyped,
    InternalApiScenarioLanguageToJSON,
    InternalApiScenarioLanguageToJSONTyped,
} from './InternalApiScenarioLanguage';

/**
 * 
 * @export
 * @interface InternalApiScenarioVersionCommand
 */
export interface InternalApiScenarioVersionCommand {
    /**
     * 
     * @type {InternalApiScenarioVersionStatus}
     * @memberof InternalApiScenarioVersionCommand
     */
    status: InternalApiScenarioVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionCommand
     */
    details: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionCommand
     */
    query: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionCommand
     */
    note?: string;
    /**
     * 
     * @type {InternalApiScenarioLanguage}
     * @memberof InternalApiScenarioVersionCommand
     */
    language: InternalApiScenarioLanguage;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioVersionCommand
     */
    suppressionInterval?: number;
    /**
     * 
     * @type {InternalApiPeriodicScenarioAttributes}
     * @memberof InternalApiScenarioVersionCommand
     */
    periodicScenarioAttributes?: InternalApiPeriodicScenarioAttributes;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenarioVersionCommand
     */
    parameters: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionCommand
     */
    logic: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioVersionCommand
     */
    segments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioVersionCommand
     */
    excludedSegments?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenarioVersionCommand
     */
    includeRelatedTransactions?: boolean;
}



/**
 * Check if a given object implements the InternalApiScenarioVersionCommand interface.
 */
export function instanceOfInternalApiScenarioVersionCommand(value: object): value is InternalApiScenarioVersionCommand {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('query' in value) || value['query'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('logic' in value) || value['logic'] === undefined) return false;
    return true;
}

export function InternalApiScenarioVersionCommandFromJSON(json: any): InternalApiScenarioVersionCommand {
    return InternalApiScenarioVersionCommandFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'status': InternalApiScenarioVersionStatusFromJSON(json['status']),
        'details': json['details'],
        'query': json['query'],
        'note': json['note'] == null ? undefined : json['note'],
        'language': InternalApiScenarioLanguageFromJSON(json['language']),
        'suppressionInterval': json['suppressionInterval'] == null ? undefined : json['suppressionInterval'],
        'periodicScenarioAttributes': json['periodicScenarioAttributes'] == null ? undefined : InternalApiPeriodicScenarioAttributesFromJSON(json['periodicScenarioAttributes']),
        'parameters': ((json['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'logic': json['logic'],
        'segments': json['segments'] == null ? undefined : json['segments'],
        'excludedSegments': json['excludedSegments'] == null ? undefined : json['excludedSegments'],
        'includeRelatedTransactions': json['includeRelatedTransactions'] == null ? undefined : json['includeRelatedTransactions'],
    };
}

export function InternalApiScenarioVersionCommandToJSON(json: any): InternalApiScenarioVersionCommand {
    return InternalApiScenarioVersionCommandToJSONTyped(json, false);
}

export function InternalApiScenarioVersionCommandToJSONTyped(value?: InternalApiScenarioVersionCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': InternalApiScenarioVersionStatusToJSON(value['status']),
        'details': value['details'],
        'query': value['query'],
        'note': value['note'],
        'language': InternalApiScenarioLanguageToJSON(value['language']),
        'suppressionInterval': value['suppressionInterval'],
        'periodicScenarioAttributes': InternalApiPeriodicScenarioAttributesToJSON(value['periodicScenarioAttributes']),
        'parameters': ((value['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'logic': value['logic'],
        'segments': value['segments'],
        'excludedSegments': value['excludedSegments'],
        'includeRelatedTransactions': value['includeRelatedTransactions'],
    };
}

